import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar } from '@fortawesome/free-solid-svg-icons';

const RoutePlanVehicles = ({ formData, onChange }) => {
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    setVehicles(formData || []);
  }, [formData]);

  const onFieldChange = (index, fieldName, newValue) => {
    const newVehicles = [...vehicles];
    newVehicles[index][fieldName] = newValue;
    setVehicles(newVehicles);
    onChange(newVehicles);
  };

  const addVehicle = () => {
    const newVehicles = [...vehicles, { count: '1', capacity: '6', vehicleId: `Vehicle ${vehicles.length + 1}` }];
    setVehicles(newVehicles);
    onChange(newVehicles);
  };

  const removeVehicle = (index) => {
    const newVehicles = [...vehicles];
    newVehicles.splice(index, 1);
    setVehicles(newVehicles);
    onChange(newVehicles);
  };

  return (
    <div className="form-block">
      <div className="m-b-2">
        <h5 className="m-b-2">
          🚚 <FormattedMessage id="route.plan.form.field.vehicles.label" />
        </h5>
      </div>

      <div className="m-b-3">
        {vehicles.map((vehicle, index) => {
          return (
            <div className="route-plan-form__vehicles-vehicle m-b-2" key={index}>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'route.plan.form.field.vehicles.vehicle.id.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={vehicle.vehicleId}
                      onChange={(e) => onFieldChange(index, 'vehicleId', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'route.plan.form.field.vehicles.capacity.label'} />
                    </label>
                    <div className="m-b-1">
                      <input
                        className="form-control"
                        placeholder=""
                        type="text"
                        value={vehicle.capacity}
                        onChange={(e) => onFieldChange(index, 'capacity', e.target.value)}
                      />
                    </div>
                    <p className="help-block">
                      <FormattedMessage id={'route.plan.form.field.vehicles.capacity.help'} />
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="form-group">
                    <label className="control-label">
                      <FormattedMessage id={'route.plan.form.field.vehicles.count.label'} />
                    </label>
                    <input
                      className="form-control"
                      placeholder=""
                      type="text"
                      value={vehicle.count}
                      onChange={(e) => onFieldChange(index, 'count', e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <button onClick={() => removeVehicle(index)} className="btn btn-default btn-small">
                  <FormattedMessage id={'route.plan.form.field.vehicles.remove'} />
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="btn btn-normal-link m-b-1" onClick={addVehicle}>
        <small>
          <FontAwesomeIcon icon={faCar} /> <FormattedMessage id={'route.plan.form.field.vehicles.add'} />
        </small>
      </div>
    </div>
  );
};

export default RoutePlanVehicles;
